import { Docker } from "../../../../types/docker";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";
import { LATEST_DOCKER_IMAGE_ID } from "../../../actions/notebook/docker";

export const docker = (
  state: Docker = {
    images: [],
    selectedVersion: "original",
    imageId: LATEST_DOCKER_IMAGE_ID,
    pinningType: "original",
  },
  action: NotebookAction
): Docker => {
  switch (action.type) {
    case NotebookActionKey.SET_KERNEL_SPEC:
      return {
        ...state,
        imageId: action.payload.pinnedDockerImage
          ? action.payload.pinnedDockerImage
          : LATEST_DOCKER_IMAGE_ID,
        pinningType: action.payload.dockerImagePinningType,
      };
    case NotebookActionKey.SET_DOCKER_IMAGES:
      return {
        ...state,
        images: action.payload.images,
        selectedVersion: action.payload.selectedVersion,
      };
    case NotebookActionKey.SET_DOCKER_IMAGE:
      return {
        ...state,
        imageId: action.payload.imageId,
      };
    case NotebookActionKey.SET_DOCKER_PINNING_TYPE:
      return {
        ...state,
        pinningType: action.payload.pinningType,
      };
    default:
      return state;
  }
};
